import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function InsidersBox() {
    const [email, setEmail] = useState("");
    const [done, setDone] = useState(false);
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (!email.includes("@")) {
            toast.error("Enter a valid email");
            return;
        }
        setBusy(true);
        try {
            await api.post("/public/insiders", { email });
            setDone(true);
        } catch {
            toast.error("Something went wrong — please try again");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="mt-10 p-5 md:p-6 border border-cream/30 rounded-sm" data-testid="insiders-box">
            <h4 className="font-serif text-2xl">Island Gold Insiders</h4>
            <p className="mt-1 text-sm">Early-drop news first — before anyone else hears about a new batch.</p>
            {done ? (
                <p className="mt-4 text-sm font-semibold" data-testid="insiders-success">Mahalo — you're an Insider now.</p>
            ) : (
                <form onSubmit={submit} className="mt-4 flex flex-wrap gap-3 items-center" data-testid="insiders-form">
                    <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="your@email.com"
                        className="flex-1 min-w-[200px] bg-transparent border-b border-cream/40 py-2 outline-none"
                        data-testid="insiders-email-input" />
                    <button type="submit" disabled={busy} className="btn-pill" style={{ background: "#3d2a0c", color: "#fdf3dc" }}
                        data-testid="insiders-submit">
                        {busy ? "…" : "Join Insiders"}
                    </button>
                </form>
            )}
        </div>
    );
}
